import { PatientId, WithPatientId } from '@/modules/surgicalEvent';
import { doctorBffApi } from '@/modules';
import { PostopSurgeryInfoService } from './postopSurgeryInfo.service';
import { PostopSurgeryInfo } from './postopSurgeryInfo.model';
import { wrapError } from '../../../error';

export const postopSurgeryInfoApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    postopSurgeryInfo: builder.query<PostopSurgeryInfo, PatientId>({
      queryFn: ({ patientId }) =>
        PostopSurgeryInfoService.getInstance(patientId)
          .fetch()
          .catch(wrapError),
      providesTags: (result, error, { patientId }) => [
        { type: 'PostopSurgeryInfo', id: patientId }
      ]
    }),

    patchPostopSurgeryInfo: builder.mutation<
      PostopSurgeryInfo,
      WithPatientId<Partial<PostopSurgeryInfo>>
    >({
      queryFn: ({ patientId, ...postopSurgeryInfo }) =>
        PostopSurgeryInfoService.getInstance(patientId)
          .patch(postopSurgeryInfo)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId }) => [
        { type: 'PostopSurgeryInfo', id: patientId },
        { type: 'PostopInfo', id: patientId },
        'Dashboard'
      ]
    })
  }),
  overrideExisting: false
});

export const { usePostopSurgeryInfoQuery, usePatchPostopSurgeryInfoMutation } =
  postopSurgeryInfoApi;
